import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import api from "../../Environment";
import ContentLoader from "../Static/contentLoader";
import Slider from "../SliderView/MainSlider";
import {
  handleMediaImgError,
  resolveMediaUrl,
} from "../Helper/mediaUrl";
import RichTextContent from "../Helper/RichTextContent";
import { t } from "react-multi-lang";
import "./castCrewDetail.css";

/**
 * Person detail: picture + name + description + filmography.
 * Uses existing v4/cast_crews/videos (now returns cast object).
 */
class CastCrewDetail extends Component {
  state = {
    loading: true,
    notFound: false,
    cast: null,
    videoList: null,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    const prevId =
      prevProps.match && prevProps.match.params
        ? prevProps.match.params.id
        : null;
    const nextId =
      this.props.match && this.props.match.params
        ? this.props.match.params.id
        : null;
    if (prevId !== nextId) {
      this.load();
    }
  }

  load = () => {
    const id =
      this.props.match && this.props.match.params
        ? this.props.match.params.id
        : null;
    const routeState =
      (this.props.location && this.props.location.state) || {};

    if (!id) {
      this.setState({ loading: false, notFound: true });
      return;
    }

    const seedCast =
      routeState.cast_crew_id || routeState.name
        ? {
            id: routeState.cast_crew_id || id,
            name: routeState.name || "",
            image: routeState.image || "",
            description: routeState.description || "",
          }
        : null;

    this.setState({ loading: true, notFound: false, cast: seedCast });

    api
      .postMethod("v4/cast_crews/videos", {
        skip: 0,
        cast_crew_id: id,
      })
      .then((response) => {
        const body = response && response.data;
        if (!body || body.success !== true) {
          this.setState({
            loading: false,
            notFound: !seedCast,
            cast: seedCast,
            videoList: [],
          });
          return;
        }
        const cast = body.cast || seedCast;
        const videos = Array.isArray(body.data) ? body.data : [];
        this.setState({
          loading: false,
          notFound: !cast,
          cast: cast,
          videoList: videos,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          notFound: !seedCast,
          cast: seedCast,
          videoList: [],
        });
      });
  };

  chunkArray(myArray, chunkSize) {
    const results = [];
    const copy = Array.isArray(myArray) ? [...myArray] : [];
    while (copy.length) {
      results.push(copy.splice(0, chunkSize));
    }
    return results;
  }

  render() {
    const { loading, notFound, cast, videoList } = this.state;

    if (loading && !cast) {
      return <ContentLoader />;
    }

    if (notFound || !cast) {
      return (
        <div className="main p-40 cast-crew-detail">
          <p>{t("cast_crew_not_found") || "Cast & crew not found."}</p>
          <Link to="/home">{t("home") || "Home"}</Link>
        </div>
      );
    }

    const name = cast.name || "";
    const description = cast.description || "";
    const image = resolveMediaUrl(cast.image);
    const rows =
      videoList && videoList.length ? this.chunkArray([...videoList], 5) : [];

    return (
      <div className="main p-40 cast-crew-detail">
        <Helmet>
          <title>{name ? `${name} — Cast & Crew` : "Cast & Crew"}</title>
        </Helmet>

        <header className="cast-crew-detail__header">
          <div className="cast-crew-detail__avatar-wrap">
            <img
              className="cast-crew-detail__avatar"
              src={image}
              alt=""
              onError={handleMediaImgError}
            />
          </div>
          <div className="cast-crew-detail__meta">
            <h1 className="cast-crew-detail__name">{name}</h1>
            {description ? (
              <RichTextContent
                html={description}
                className="cast-crew-detail__description"
              />
            ) : null}
          </div>
        </header>

        <section className="cast-crew-detail__filmography" aria-label="Filmography">
          <h2 className="cast-crew-detail__section-title">
            {t("filmography") || "Filmography"}
          </h2>
          {loading ? (
            <ContentLoader />
          ) : rows.length ? (
            rows.map((movies, index) => (
              <Slider
                key={`cast-filmography-${index}`}
                title={index === 0 ? name : ""}
                movies={movies}
              />
            ))
          ) : (
            <p className="cast-crew-detail__empty">
              {t("cast_crews_no_videos") || "No titles linked yet."}
            </p>
          )}
        </section>
      </div>
    );
  }
}

export default CastCrewDetail;
